export default {"src":"https://static.finncdn.no/_c/travel/_next/static/media/rondane.75a687df.svg","height":567,"width":1134,"blurWidth":0,"blurHeight":0};